import React, { Component } from 'react';
import { View, Image, Text, Platform, Dimensions } from 'react-native';
import YoutubePlayer from 'react-native-youtube-iframe';
import ReactPlayer from 'react-player';

let deviceWidth = Dimensions.get('window').width;

class VideoPlayer extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const tempArr = this.props.url.split('/');
    const playlist = tempArr[tempArr.length - 1];

    return (
      <View key={2637816} style={{ alignSelf: 'center' }}>
        {Platform.OS == 'web' ? (
          <iframe
            src={`${this.props.url}?autoplay=1&mute=0&enablejsapi=1&loop=1&playlist=${playlist}`}
            //src="https://www.youtube.com/embed/R_coPfg5h_0"
            allowFullScreen={true}
            allow='autoplay'
            title='video'
            width={deviceWidth <= 768 ? '350' : '300'}
            height={deviceWidth <= 768 ? '400' : '300'}
          />
        ) : (
          <YoutubePlayer
            height={300}
            width={Platform.OS == 'ios' ? 340 : 300}
            play={true}
            videoId={playlist}
            initialPlayerParams={{
              controls: true,
              loop: true,
              preventFullScreen: false,
            }}
            onChangeState={(state) => {
              if (state === 'ended') {
                this.playerRef.seekTo(0);
              }
            }}
            ref={(e) => {
              this.playerRef = e;
            }}
          />
        )}
      </View>
    );
  }
}
export default VideoPlayer;
